// app/javascript/controllers/active_link_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Update once on connection (initial page load)
    this.updateActiveLinks();

    // Listen for Turbo's render event that fires after navigation updates the page
    document.addEventListener(
      "turbo:render",
      this.updateActiveLinks.bind(this)
    );
  }

  disconnect() {
    document.removeEventListener(
      "turbo:render",
      this.updateActiveLinks.bind(this)
    );
  }

  updateActiveLinks() {
    const currentPath = window.location.pathname;
    // Iterate through all sidebar links
    this.element.querySelectorAll("a.nav-menu-item").forEach((link) => {
      // If the link's href exactly matches the current path, mark it active
      if (link.getAttribute("href") === currentPath) {
        link.classList.add("active");
        link.setAttribute("aria-current", "page");
      } else {
        link.classList.remove("active");
        link.removeAttribute("aria-current");
      }

      // If you have inner SVGs or other elements that should change appearance,
      // update them here (for example, toggling an "active-icon" class)
      const svg = link.querySelector("svg");
      if (svg) {
        if (link.getAttribute("href") === currentPath) {
          svg.classList.add("active-icon");
        } else {
          svg.classList.remove("active-icon");
        }
      }
    });
  }
}
